module.exports = __webpack_public_path__ + "img/code.77bd2510.png";